import React, { Component } from 'react';
import styles from './HoverBoxStyles';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { HOVER_BOX_ID } from 'crazyEditor/core/constants/editorConstants';
import { getElementStageLayout } from '../MouseCatcherUtils';
import { getElementDefinitionProps } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { connect } from 'react-redux';
import { getHoveredElement, getElementsForView } from 'crazyEditor/redux/modules/element/elementSelectors';
import { getElementName } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import {closeBox} from 'shared/icons/index';
import IconButton from 'material-ui/IconButton';
import SvgIcon from 'material-ui/SvgIcon';
import * as Colors from 'material-ui/styles/colors';
import { deleteDesktopElement } from 'crazyEditor/redux/modules/element/actions/desktopElementActions';
import { isChildElement } from 'crazyEditor/core/elements/utils/elementFilterUtils';

@connect(
  state => ({
    hoveredElement: getHoveredElement(state),
    selectedElementIds: state.stage.selectedElementIds,
    isDraggingElement: state.stage.isDraggingElement,
    isResizingElement: state.stage.isResizingElement,
  }),
  {deleteDesktopElement}
)
@Radium
export default class HoverBox extends Component {
  state = {};

  componentWillReceiveProps(nextProps) {
    if (this.shouldRenderHoverBox(nextProps) && !this.shouldRenderHoverBox(this.props)) {
      this.setState({deleteButtonHovered: false});
    }
  }

  getStyles(draggable, hoveredElement) {
    return [
      styles.hoverBox,
      {
        cursor: draggable ? 'move' : null,
        border: `1px dashed ${this.getColor()}`
      },
      getElementStageLayout(hoveredElement)
    ];
  }

  getColor() {
    const {deleteButtonHovered} = this.state;
    return deleteButtonHovered ? Colors.redA100 : Colors.limeA700;
  }

  shouldRenderHoverBox(props = this.props) {
    const { selectedElementIds, isDraggingElement, hoveredElement, isResizingElement } = props;
    return hoveredElement && hoveredElement.id !== selectedElementIds[0] && !isDraggingElement && !isResizingElement;
  }

  handleDeleteButtonEnter = () => {
    this.setState({deleteButtonHovered: true});
  };

  handleDeleteButtonLeave = () => {
    this.setState({deleteButtonHovered: false});
  };

  handleDeleteButtonMouseDown = (event) => {
    const {deleteDesktopElement, hoveredElement} = this.props;
    event.stopPropagation();
    deleteDesktopElement(hoveredElement.id);
  };

  render() {
    if (!this.shouldRenderHoverBox()) {
      return null;
    }
    const {deleteButtonHovered} = this.state;
    const { hoveredElement } = this.props;
    const elementDefinitionProps = getElementDefinitionProps(hoveredElement.type);
    const elementName = getElementName(hoveredElement);
    return (
      <div id={HOVER_BOX_ID}
           style={this.getStyles(elementDefinitionProps.draggable, hoveredElement)}>
        {
          !deleteButtonHovered && !isChildElement(hoveredElement) &&
          <div style={{position: 'absolute', left: 0, bottom: 'calc(100% + 3px)', color: Colors.lightGreen900, padding: 3, fontSize: 12, backgroundColor: this.getColor()}}>
            {elementName}
          </div>
        }
        {
          !isChildElement(hoveredElement) && false && // temporarily disabled, waiting for semi to lehisager on himself for CL-2379
          <IconButton
            style={{position: 'absolute', right: -14, bottom: 'calc(100% - 12px)', padding: 0}}
            onMouseEnter={this.handleDeleteButtonEnter}
            onMouseLeave={this.handleDeleteButtonLeave}
            onMouseDown={this.handleDeleteButtonMouseDown}
          >
            <SvgIcon
              color={this.getColor()}
              hoverColor={Colors.redA100}
            >
              <path d={closeBox}/>
            </SvgIcon>
          </IconButton>
        }
      </div>
    );
  }
}